export default __webpack_public_path__ + "static/media/background.34844f17.mp3";